import AbstractRepository from "@/repositories/AbstractRepository";

export default class AiInteractionRepository extends AbstractRepository {
    protected static resource: string = "aiinteraction";

    protected static defaultFields: string[] = [
        "question",
    ];
}
